import { Directive } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Directive()
export abstract class NumberFieldComponent extends AbstractFieldComponent<number> {

    readonly minFractionDigits: number;
    readonly maxFractionDigits: number;
    readonly min: number;
    readonly max: number;
    readonly mode: string;
    readonly currency: string | null;
    readonly locale: string;
    readonly prefix: string;
    readonly suffix: string;

    constructor( i18nIdentifier: string,
        numberProperties: {
            min?: number;
            max?: number;
            minFractionDigits?: number;
            maxFractionDigits?: number;
            mode?: Mode;
            currency?: string;
            locale?: string;
            prefix?: string;
            suffix?: string;
        }
    ) {
        super( i18nIdentifier );
        this.min = numberProperties.min ?? Number.MIN_SAFE_INTEGER;
        this.max = numberProperties.max ?? Number.MAX_SAFE_INTEGER;
        this.minFractionDigits = numberProperties.minFractionDigits ?? 0;
        this.maxFractionDigits = numberProperties.maxFractionDigits ?? 0;
        this.mode = numberProperties.mode ?? Mode.DECIMAL;
        this.currency = ( this.mode === Mode.CURRENCY ) ? ( numberProperties.currency ?? 'EUR' ) : null;
        this.locale = numberProperties.locale ?? 'de-DE';
        this.prefix = numberProperties.prefix ?? '';
        this.suffix = numberProperties.suffix ?? '';
    };
}

export enum Mode {
    CURRENCY = 'currency', DECIMAL = 'decimal'
}
